import { EyeIcon } from "@heroicons/react/outline";
import { FormatMoney } from "./../../utils/formatMoney";
import { formatDate } from "./../../utils/convertDate";

export const ScheduledTransferTable = ({ transfers, onViewDetails }) => {
  const statusStyles = {
    Success: "bg-green-100 text-green-800",
    Pending: "bg-amber-100 text-amber-800",
    Failed: "bg-red-100 text-red-800",
    Active: "bg-green-100 text-green-800",
    Expired: "bg-orange-100 text-orange-800",
    Disabled: "bg-red-100 text-red-800",
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full table-fixed divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Account Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Amount
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Receiver's Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Receiver's Account Number
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Start Date
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      End Date
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Next Scheduled Date
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Scheduled Status
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Duration
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Narration
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {transfers.map((person, i) => (
                    <tr key={i} className="bg-gray-50 hover:bg-gray-100">
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.sourceAccountName}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {FormatMoney(person.amount)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.destinationAccountName}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.destinationAccountNumber}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {formatDate(person.startDate)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {formatDate(person.endDate)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {formatDate(person.nextDebitDate)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm">
                        <span
                          className={classNames(
                            statusStyles[person.scheduleStatus] ||
                              "bg-gray-100 text-gray-800",
                            "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                          )}
                        >
                          {person.scheduleStatus}
                        </span>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.frequency}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {person.narration || "-"}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <button
                          onClick={() => onViewDetails(person)}
                          className="text-indigo-600 hover:text-indigo-900 p-1 rounded hover:bg-indigo-50"
                          title="View Details"
                        >
                          <EyeIcon className="h-5 w-5" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
